<template>
  <div v-if="loaded">
    <div v-if="errorMessage" class="pd-alert-msg">
      {{ errorMessage }}
    </div>
    <r-data-list :headdata="headdata" :listdata="listData" :opt="opts">
      <template v-slot:titleextrabuttons>
        <r-btn
          type="secondary"
          @click="saveReorder"
          v-if="listData && listData.length > 0"
          >Sıralamayı Kaydet</r-btn
        >
      </template>
      <template v-slot:rowextrabtn="{ datarow }">
        <r-btn @click="openEdit(datarow)">Düzenle</r-btn>
        <r-btn @click="openValues(datarow)" type="secondary"
          >Değerleri Yönet</r-btn
        >
        <r-btn
          @click="toggleDefinition(datarow)"
          :type="datarow.isActive ? 'danger' : 'success'"
          >{{ datarow.isActive ? "Pasif Et" : "Aktif Et" }}</r-btn
        >
        <r-btn @click="deleteDefinition(datarow)" type="danger">Sil</r-btn>
      </template>
    </r-data-list>
  </div>

  <property-definition-modal
    v-model="showForm"
    :definition="form"
    :title="formTitle"
    :defaultSortOrder="listData && listData.length ? listData.length + 1 : 1"
    @save="saveForm"
  />

  <property-values-modal
    v-model:isactive="showValues"
    :definition="selectedDefinition"
  />
</template>

<script>
import { ref, onBeforeMount, computed } from "vue";
import PropertyDefinitionModal from "./PropertyDefinitionModal.vue";
import PropertyValuesModal from "./PropertyValuesModal.vue";
import { useStore } from "vuex";

export default {
  components: { PropertyDefinitionModal, PropertyValuesModal },
  setup() {
    const store = useStore();
    const loaded = ref(false);
    const listData = ref([]);
    const showForm = ref(false);
    const formTitle = ref("Yeni Özellik");
    const form = ref({
      id: null,
      name: "",
      description: "",
      dataType: 1,
      displayType: 1,
      cardinality: 1,
      isRequired: false,
      sortOrder: 1,
      isActive: true
    });
    const showValues = ref(false);
    const selectedDefinition = ref(null);
    const errorMessage = ref("");
    const isSaving = ref(false);

    // Enums modal içinde yönetiliyor; burada ayrıca tanımlamaya gerek yok

    const headdata = computed(() => [
      { title: "Ad", key: "name", style: { width: "20%" } },
      { title: "Veri Tipi", key: "dataType", style: { width: "10%" } },
      { title: "Görünüm", key: "displayType", style: { width: "12%" } },
      { title: "Çokluk", key: "cardinality", style: { width: "10%" } },
      {
        title: "Zorunlu",
        key: "isRequired",
        type: "checkbox",
        style: { width: "8%", justifyContent: "center" }
      },
      {
        title: "Aktif",
        key: "isActive",
        type: "checkbox",
        style: { width: "8%", justifyContent: "center" }
      },
      { title: "Sıra", key: "sortOrder", style: { width: "8%" } }
    ]);

    const opts = ref({
      title: "Özellik Tanımları",
      buttons: { style: { width: "30%" } }
    });

    const getDefinitions = async () => {
      const res = await store.dispatch("getDatas", {
        api: "PropertyDefinitions"
      });
      const arr = res && (res.data ?? res.Data);
      listData.value = Array.isArray(arr) ? arr : [];
      if (!Array.isArray(arr)) {
        console.warn("PropertyDefinitions GET unexpected response:", res);
      }
    };

    const openCreate = () => {
      formTitle.value = "Yeni Özellik";
      form.value = {
        id: null,
        name: "",
        description: "",
        dataType: 1,
        displayType: 1,
        cardinality: 1,
        isRequired: false,
        sortOrder: (listData.value?.length || 0) + 1,
        isActive: true
      };
      showForm.value = true;
    };
    // Header butonunu RDataList'in default add butonuna da bağlayalım
    opts.value.buttons.add = {
      show: true,
      pos: "title",
      txt: "Yeni Özellik",
      func: openCreate
    };
    const openEdit = async d => {
      formTitle.value = "Özellik Düzenle";
      // Detay bilgisini values ile birlikte çek
      const res = await store.dispatch("getDatas", {
        api: `PropertyDefinitions/${d.id}/detail`
      });
      if (res && res.result && res.data) {
        const detail = res.data;
        form.value = {
          id: detail.id,
          name: detail.name || "",
          description: detail.description || "",
          dataType: detail.dataType,
          displayType: detail.displayType,
          cardinality: detail.cardinality,
          isRequired: detail.isRequired || false,
          sortOrder: detail.sortOrder || 1,
          isActive: detail.isActive !== undefined ? detail.isActive : true,
          values: detail.values || detail.propertyDefinitionValues || []
        };
      } else {
        // Fallback: sadece mevcut datayı kullan
        form.value = { ...d };
      }
      showForm.value = true;
    };
    const saveForm = async payload => {
      if (isSaving.value) return;
      const data = payload || form.value;
      if (!data.name) return;
      isSaving.value = true;
      try {
      // Normalize types to satisfy backend enum/int expectations
      data.dataType = Number(data.dataType);
      data.displayType = Number(data.displayType);
      data.cardinality = Number(data.cardinality);
      data.isRequired = !!data.isRequired;
      data.sortOrder = Number(data.sortOrder || 1);
      const isUpdate = !!data.id;
      const api = isUpdate
        ? "PropertyDefinitions/Update"
        : "PropertyDefinitions/Add";
      // API yalnızca json bekler, geçici alanları göndermeyelim
      const clean = { ...data };
      delete clean.__values;
      const res = await store.dispatch("postDatas", { api, data: clean });
      if (res && res.result) {
        // Eğer modal çoklu değer girdiyse, onları da kaydedelim
        if (payload && payload.__values && payload.__values.length > 0) {
          const defId =
            res && res.data && res.data.id ? res.data.id : data.id || null;
          if (defId) {
            for (const v of payload.__values) {
              const valApi = v.id
                ? "PropertyDefinitions/UpdateValue"
                : "PropertyDefinitions/AddValue";
              const vdata = { ...v, propertyDefinitionId: defId };
              vdata.sortOrder = Number(vdata.sortOrder || 1);
              await store.dispatch("postDatas", { api: valApi, data: vdata });
            }
          }
        }
        showForm.value = false;
        await getDefinitions();
      }
      } finally {
        isSaving.value = false;
      }
    };

    const openValues = d => {
      selectedDefinition.value = d;
      showValues.value = true;
    };
    const toggleDefinition = async d => {
      const res = await store.dispatch("postDatas", {
        api: `PropertyDefinitions/${d.id}/toggle`
      });
      if (res && res.result) {
        errorMessage.value = "";
        await getDefinitions();
      } else {
        errorMessage.value =
          res?.msgDetail?.msg ||
          "Özellik tanımının aktif/pasif durumu güncellenemedi.";
        await getDefinitions();
      }
    };
    const deleteDefinition = async d => {
      if (isSaving.value) return;
      isSaving.value = true;
      try {
        const res = await store.dispatch("postDatas", {
          api: `PropertyDefinitions/delete/${d.id}`,
          data: {}
        });
        if (res && res.result) {
          errorMessage.value = "";
          await getDefinitions();
        } else {
          errorMessage.value =
            res?.msgDetail?.msg || "Özellik tanımı silinemedi.";
          await getDefinitions();
        }
      } finally {
        isSaving.value = false;
      }
    };
    const saveReorder = async () => {
      if (isSaving.value) return;
      isSaving.value = true;
      try {
        const ids = listData.value.map(x => x.id);
        await store.dispatch("postDatas", {
          api: "PropertyDefinitions/reorder",
          data: ids
        });
        await getDefinitions();
      } finally {
        isSaving.value = false;
      }
    };

    onBeforeMount(async () => {
      await getDefinitions();
      loaded.value = true;
    });

    return {
      store,
      loaded,
      listData,
      headdata,
      opts,
      errorMessage,
      openCreate,
      openEdit,
      showForm,
      formTitle,
      form,
      saveForm,
      openValues,
      showValues,
      selectedDefinition,
      toggleDefinition,
      deleteDefinition,
      saveReorder
    };
  }
};
</script>

<style scoped>
.form-row {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
}

.pd-alert-msg {
  margin-bottom: 8px;
  padding: 8px 10px;
  border-radius: 4px;
  background-color: #ffebee;
  color: #b71c1c;
  font-size: 13px;
}
</style>
